import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_BEGIN,
  APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_SUCCESS,
  APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE,
  APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function addEnvironmentInProject(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_BEGIN,
    });
    const { version, projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/environments`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddEnvironmentInProjectError() {
  return {
    type: APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_BEGIN:
      return {
        ...state,
        addEnvironmentInProjectPending: true,
        addEnvironmentInProjectError: null,
      };

    case APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_SUCCESS:
      return {
        ...state,
        addEnvironmentInProjectPending: false,
        addEnvironmentInProjectError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE:
      return {
        ...state,
        addEnvironmentInProjectPending: false,
        addEnvironmentInProjectError: action.data.error,
      };

    case APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        addEnvironmentInProjectError: null,
      };

    default:
      return state;
  }
}
